import React from 'react';
import { motion } from 'framer-motion';
import { calculatePasswordStrength } from '../../schemas/authSchemas';

const PasswordStrength = ({ password }) => {
  const strength = calculatePasswordStrength(password);
  
  const getStrengthLabel = () => {
    if (strength === 0) return '';
    if (strength === 1) return 'Débil';
    if (strength === 2) return 'Media';
    return 'Fuerte';
  };
  
  const getStrengthColor = () => {
    if (strength === 1) return 'bg-destructive';
    if (strength === 2) return 'bg-yellow-500';
    if (strength === 3) return 'bg-success';
    return 'bg-muted';
  };

  if (!password) return null;

  return (
    <div className="mt-2">
      <div className="flex gap-1">
        {[1, 2, 3].map((level) => (
          <motion.div
            key={level}
            initial={{ scaleX: 0 }}
            animate={{ scaleX: strength >= level ? 1 : 0 }}
            className={`h-1 flex-1 rounded ${
              strength >= level ? getStrengthColor() : 'bg-muted'
            }`}
          />
        ))}
      </div>
      {strength > 0 && (
        <p className="text-xs mt-1 text-muted-foreground">
          Fortaleza: <span className="font-medium">{getStrengthLabel()}</span>
        </p>
      )}
    </div>
  );
};

export default PasswordStrength;